import { clientsForIssuer } from "./clientAccess";
import { withClientFinancials } from "./clientFinancials";

export const ALL_BUSINESSES_SCOPE = "all";

export const resolveBusinessScopeId = (businesses = [], requestedScopeId = ALL_BUSINESSES_SCOPE, directoryComplete = true) => {
  if (!businesses.length) return ALL_BUSINESSES_SCOPE;
  if (businesses.length === 1 && directoryComplete) return businesses[0].id;
  return businesses.some((business) => business.id === requestedScopeId)
    ? requestedScopeId
    : ALL_BUSINESSES_SCOPE;
};

const sharedOrMatchesBusiness = (record, businessId) => {
  const recordBusinessId = record?.businessId || record?.issuerId;
  return !recordBusinessId || recordBusinessId === businessId;
};

export const scopeWorkspaceByBusiness = (records, businessId) => {
  if (!(records.businesses || []).length) return {
    ...records,
    businesses: [],
    clients: [],
    services: [],
    invoices: [],
    intakeItems: [],
    documentExpectations: [],
    bankTransactions: [],
    quickBooksExports: [],
    communications: [],
    workReminders: [],
    workTasks: [],
    workItemActivities: [],
    activityLog: [],
  };
  if (!businessId || businessId === ALL_BUSINESSES_SCOPE) return records;

  const businesses = (records.businesses || []).filter((business) => business.id === businessId);
  if (!businesses.length) return { ...records, businesses: [] };

  const invoices = (records.invoices || []).filter((invoice) => invoice.issuerId === businessId);
  const clients = clientsForIssuer(records.clients || [], businessId)
    .map((client) => withClientFinancials(client, invoices));
  const services = (records.services || []).filter((service) => sharedOrMatchesBusiness(service, businessId));
  const intakeItems = (records.intakeItems || []).filter((item) => item.businessId === businessId);
  const documentExpectations = (records.documentExpectations || []).filter((item) => item.businessId === businessId);
  const bankTransactions = (records.bankTransactions || []).filter((item) => item.businessId === businessId);
  const quickBooksExports = (records.quickBooksExports || []).filter((item) => item.businessId === businessId);
  const communications = (records.communications || []).filter((item) => item.businessId === businessId);
  const workReminders = (records.workReminders || []).filter((item) => item.businessId === businessId);
  const workTasks = (records.workTasks || []).filter((item) => item.businessId === businessId);
  const workItemActivities = (records.workItemActivities || []).filter((item) => item.businessId === businessId);

  const visibleEntityIds = {
    business: new Set([businessId]),
    invoice: new Set(invoices.map((item) => item.id)),
    client: new Set(clients.map((item) => item.id)),
    intake: new Set(intakeItems.map((item) => item.id)),
    "bank-transaction": new Set(bankTransactions.map((item) => item.id)),
    "quickbooks-export": new Set(quickBooksExports.map((item) => item.id)),
    communication: new Set(communications.map((item) => item.id)),
    "work-reminder": new Set(workReminders.map((item) => item.id)),
    "work-task": new Set(workTasks.map((item) => item.id)),
  };
  const activityLog = (records.activityLog || []).filter((entry) => {
    if (entry.businessId) return entry.businessId === businessId;
    return visibleEntityIds[entry.entityType]?.has(entry.entityId) || false;
  });

  return {
    ...records,
    businesses,
    clients,
    services,
    invoices,
    intakeItems,
    documentExpectations,
    bankTransactions,
    quickBooksExports,
    communications,
    workReminders,
    workTasks,
    workItemActivities,
    activityLog,
  };
};
